module.exports = __webpack_public_path__ + "img/bottom-right-corner.5d31b2e6.svg";